import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { ValidatorsService } from 'src/app/shared/services/validators.service';

export interface IProfilePhoneEditForm {
  phone: string;
}

@Component({
    selector: 'account-profile-phone-edit-form',
    templateUrl: './profile-phone-edit-form.component.html',
    styleUrls: ['./profile-phone-edit-form.component.scss'],
    standalone: false
})
export class ProfilePhoneEditFormComponent implements OnInit {
  form: FormGroup;
  formErrors: Map<string, string> = new Map<string, string>();

  patternReference: any = {};

  @Output()
  onSubmit: EventEmitter<IProfilePhoneEditForm> = new EventEmitter<IProfilePhoneEditForm>();

  get phonePlaceHolder(): string {
    return this.translationService.translate('Account.PhoneNumber');
  }

  constructor(private fb: FormBuilder,
    //private translate: TranslateService,
    public validators: ValidatorsService,
    private translationService: TranslationService) {

  }

  ngOnInit() {
    /*
    this.form = this.fb.group({
      'phone': ['', this.validators.formBuilderValidationInitializer(true, null, null)]
    });
    */
    this.form = this.fb.group({
      phone: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null, null),
        updateOn: 'change'
      })
    });

    /*
    this.form["patternReference"] = {
      phone: null
    };
    */
    this.patternReference = {
      phone: null
    };

    //this.validators.trackInputChange(this.form);
    this.validators.trackInputChange(this.form, this.patternReference);
  }

  submit() {
    //sanitizing
    this.form.setValue(this.validators.multiSanitizerInput(this.form.value));

    if (!this.form.valid)
      return;

    this.formErrors.clear();

    this.onSubmit.emit({
      phone: this.form.get("phone").value
    });
  }
}
